import { Http } from "../Http";
export class LoginAPI {
  public static saveLogin(input: any) {
    var obj = JSON.stringify(input);
  
    var url = "api/login";
    var source = {
      userId: input.userId,
      password: input.password,
      browserNameAndVersion: input.browserNameAndVersion
   
    };
      obj = JSON.stringify(source);
    
    var obJSon = JSON.parse(obj);
 
    

    if (input.userId !== null && input.userId !== "") {
      const resultMethod = Http.axios()
        .post(url, obJSon, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(res => {
 
       
           return res;
        })
        .catch((e: any) => {
    
          return e.response;
        });
      return resultMethod;
    }
  }
 
 
}

export class TokenAPI {
  public static saveToken(input: any) {
    var obj = JSON.stringify(input);

  // const username = 'reactapp'
//   const password = 'reactapp'
   //const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
    var url = "/authenticateClient";
/*    var source = {
      grant_type: "password",
      userName: input.userId,
      password: input.password,
      clientid:"reactapp"

    };*/
    var jsk={
      "userName": input.userId,
      "password": input.password
    }
   
      obj = JSON.stringify(jsk);
 
 
    if (input.userId !== null && input.userId !== "") {
 
   
      const resultMethod = Http.axios()
        .post(url, obj, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(res => {
         
          return res;
        })
        .catch((e: any) => {
 
          return e.response;
        });
       
      return resultMethod;
    }
  }
 
 
}
